import axios from "axios";
import { updateObject } from "../utility";
import _ from "lodash";

export const login = (state, action) => {
  return updateObject(state, {
    is_auth: true,
    token: action.data.token,
    user: action.data.me,
  });
};

export const updateUser = (state, user) => {
  return updateObject(state, {
    user: user,
  });
};

export const logout = (state, action) => {
  localStorage.removeItem("token");
  localStorage.removeItem("exp");
  localStorage.removeItem("admin");
  axios.defaults.headers.common["key"] = "";
  return updateObject(state, {
    is_auth: false,
    token: "",
    user: {},
  });
};

export const updateCart = (state, data) => {
  let store = { ...state.store };
  let product = state.product;
  let cart = [...state.cart];
  // find product in user cart
  let product_index = _.findIndex(cart, ["ProductID", data.product_id]);
  // update product in cart
  if (product_index !== -1) {
    cart[product_index].Count = data.count;
  } else {
    cart = [...cart, { ProductID: data.product_id, Count: data.count }];
  }
  // update store
  store = getStore(store, cart);
  if (product.Similars)
    // update products in product details
    product.Similars = getProductDetails(product.Similars, cart);
  // update product
  if (product.ProductID === data.product_id) product.Count = data.count;
  _.remove(cart, function (p) {
    return p.Count === 0;
  });

  // update user
  let user = state.user;
  let index = _.findIndex(user.SaleProducts, ["StoreID", parseInt(store.id)]);
  user.SaleProducts[index].Products = cart;
  //

  return updateObject(state, { store, product, cart, user });
};
//
//
export const setIsAuth = (state, value) => {
  return updateObject(state, { is_auth: value });
};
///
export const addCart = (state) => {
  let cart = [];
  if (state.store.id && state.user && state.user.SaleProducts) {
    cart = _.find(state.user.SaleProducts, [
      "StoreID",
      parseInt(state.store.id),
    ]).Products;
  }
  return updateObject(state, { cart });
};
//

export const updateUserAndCart = (state, cart) => {
  let user = state.user;
  let index = _.findIndex(user.SaleProducts, [
    "StoreID",
    parseInt(state.store.id),
  ]);
  user.SaleProducts[index].Products = cart;
  return updateObject(state, { cart, user });
};

///

export const addStore = (state, data) => {
  let cart = state.cart;
  let store = { rows: [...data.rows], id: parseInt(data.id) };
  if (cart.length) {
    store = getStore(store, cart);
  }
  return updateObject(state, { store });
};
export const addProductDetails = (state, data) => {
  let product = { ...data.product };
  let cart = [...state.cart];
  if (cart.length) {
    product.Similars = getProductDetails(product.Similars, cart);
  }
  return updateObject(state, { product });
};

export const updateMessageCount = (state, count) => {
  let user = state.user;
  user.MessageUnreadCount = count;
  return updateObject(state, { user });
};

export const removeCartFromStore = (state, store_id) => {
  let user = { ...state.user };

  let index = _.findIndex(user.SaleProducts, ["StoreID", parseInt(store_id)]);
  user.SaleProducts[index].Products = [];
  return updateObject(state, { user });
};

//
const getStore = (store, cart) => {
  store.rows.forEach((row) => {
    row.Products.forEach((product) => {
      cart.forEach((p) => {
        if (product.ProductID === p.ProductID) {
          product.Count = p.Count;
        }
      });
    });
  });
  return store;
};

const getProductDetails = (similars, cart) => {
  similars.forEach((product) => {
    cart.forEach((p) => {
      if (product.ProductID === p.ProductID) {
        product.Count = p.Count;
      }
    });
  });
  return similars;
};
